module.exports = __webpack_public_path__ + "img/connection.4317b25b.svg";